import { ListGroup } from 'react-bootstrap'
import styled from 'styled-components'
import { colors } from '../../../../../const/theme'

export const Container = styled.div`
  width: 100%;
  max-width: 80%;
  margin: auto;
  background: ${({ theme }) => theme?.login?.background};
  @media (min-width: 769px) {
    width: 40%;
  }
`

export const BenefitsList = styled(ListGroup)`
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
`

export const BenefitsListItem = styled(ListGroup.Item)`
  position: relative;
  padding-left: 15px;
  margin-bottom: 15px;
  &:before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    background: ${colors.purple};
    position: absolute;
    left: -10px;
    top: 8px;
    border-radius: 10px;
  }
`
